<div *ngIf="showDevComments" class="dev-comment">src\app\landowner\components\annual-lease-grid\annual-lease-grid.component.html</div>
<div *ngIf="showDevComments" class="dev-comment">listingId={{ listingId }}</div>

<!--Table-->
<table class="adminTable">
  <!--Table head-->
  <thead>
    <tr>
      <th>ID</th>

      <!-- Listing Title - hidden if grid is used in a listing-specific context -->
      <th *ngIf="showTitle">Listing</th>

      <th>Name</th>

      <!-- <th>Avail. For Renewal</th>      -->

      <!-- <th>Auto Pay Enabled?</th> -->

      <!-- Change from Available to Start Date per https://www.notion.so/outdooraccess/Big-Project-Testing-612cd612663e4c1d9204791116f7f043 -->
      <th>Start Date</th> 


      <th>End Date</th>

      <th *ngIf="isVisible('leaseAmount')">Lease $</th>

      <th *ngIf="isVisible('feeAmount')">Service Fee $</th>

      <th *ngIf="isVisible('membershipAmount')">Membership $</th>
      <th>Commission</th>
      <th *ngIf="isVisible('escalator')">Escalator</th>

      <th>Created By</th>
      <th>Created On</th>

      <th>Updated By</th>
      <th>Updated On</th>

      <!-- Reserved column for action links/buttons -->
      <th></th>
    </tr>
  </thead>
  <!--Table head-->
  <!--Table body-->
  <tbody *ngIf="rows && !retrieving">
    <tr *ngFor="let r of rows" (click)="onRowClick(r)">
      <td class="lease-id-cell">{{ r.id }}</td>

      <td class="title-cell" *ngIf="showTitle">
        {{ r.title }}
        <link-to-new-listing-detail [listingId]="r.listingId"></link-to-new-listing-detail>
        <link-to-new-admin-listing [listingId]="r.listingId"></link-to-new-admin-listing>
      </td>

      <td class="annual-lease-name-cell">{{ r.name }}</td>

      <!-- <td>{{ r.isRecurring | yesNo }}</td> -->
      <!-- <td>{{ r.autoPayEnabled | yesNo }}</td> -->

      <td>{{ r.startDateTime | date: "shortDate" }}</td>
      <td>{{ r.endDateTime | date: "shortDate" }}</td>

      <td *ngIf="isVisible('leaseAmount')">{{ r.leaseAmount | currency: "USD":"symbol":"1.0-0" | replace: ",":"" }}</td>

      <td *ngIf="isVisible('feeAmount')">{{ r.feeAmount | currency: "USD":"symbol":"1.0-0" | replace: ",":"" }}</td>

      <td *ngIf="isVisible('membershipAmount')">{{ r.membershipAmount | currency: "USD":"symbol":"1.0-0" | replace: ",":"" }}</td>
      <td>{{ r.commission | percent }}</td>

      <td *ngIf="isVisible('escalator')">{{ r.escalator | percent }}</td>

      <td class="email-cell">{{ r.createdByEmailAddress }}</td>
      <td>{{ r.createdOn | date: "shortDate" }}</td>

      <td class="email-cell">{{ r.updatedByEmailAddress }}</td>
      <td>{{ r.updatedOn | date: "shortDate" }}</td>

      <td>
        <link-to-booking-detail [bookingId]="r.bookingId"></link-to-booking-detail>
        <div *ngIf="r.canDelete" class="link annual-lease-grid-delete-link" (click)="onDeleteClick(r)">Delete</div>
        <div
          class="annual-lease-grid-edit-link"
          *ngIf="r.canEdit"
          [ngClass]="{ 'link-disabled': deleting, link: !deleting }"
          (click)="onEditClick(r)"
        >
          Edit
        </div>

        <!-- <link-to-booking-detail [openInNewTab]="true" [bookingId]="r.bookingId"></link-to-booking-detail>
          <link-to-new-admin-listing [openInNewTab]="true" [listingId]="r.listingId"></link-to-new-admin-listing>
          <link-to-new-listing-detail [openInNewTab]="true" [listingId]="r.listingId"></link-to-new-listing-detail> -->
      </td>
    </tr>
  </tbody>
  <!--Table body-->
</table>

<spinner *ngIf="retrieving" messageRelativePosition="bottom"> </spinner>
